// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--RzTsHUJa4p","dark":"dark--cdZTDByWLU","light":"light--PBDMfQbrpm","small":"small--KMbXJNoVO+"};